import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({

  box:{
      display:"flex",
      justifyContent:"center",
     
         
    margin:"0 10px 30px 10px",
    

 
  }
}));
